
export const AppId = "E4BCBFAA-3258-4934-AA87-891AE86B6E70"
// slet API = 'https://nimblebyte-website-node-backend.azurewebsites.net/api'
let API = process.env.REACT_APP_API_ENDPOINT
export default API